import SystemDetail from "../js/components/groupManagement/SystemDetail.react";
export default SystemDetail;
